import {
  BPCDisplayConfigResponse,
  BPCDisplayConfigField,
} from '@core/interfaces/bpc-display-config';

import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Subscription } from 'rxjs';

@Component({
  name: 'bpc-entity-details-provider',
  components: {},
})
export default class EntityDetailsProvider extends Vue {
  @Prop(String) readonly entity: string;
  @Prop([String, Number]) readonly entityId: string | number;
  @Prop({ type: Boolean, default: false }) readonly fetchEntity: boolean;
  @Prop(String) readonly fetchPath: string;
  @Prop(String) readonly configPath: string;
  @Prop({ type: String, default: 'details' }) readonly displayConfigName: string;
  @Prop({
    type: Array,
    default: () => ['configLoaded'],
  })
  readonly flagsToCheckBeforeLoadEntity: Array<any>;
  @Prop({ type: String, default: 'details' }) readonly storeName: string;

  loading = true;
  loadingConfig = true;

  entitySubscription: Subscription;
  entityConfigSubscription: Subscription;

  item: AnyEntity = {};
  fields: BPCDisplayConfigField[] = [];
  hiddenFields: string[] = [];
  mainFields: string[] = [];

  get canLoadEntity(): boolean {
    return this.$store.getters[`${this.storeName}/canLoadEntity`]({
      entity: this.entity,
      flags: this.flagsToCheckBeforeLoadEntity,
    });
    // return true;
  }

  getLang() {
    const defaultLang = process.env.VUE_APP_DEFAULT_LANG || 'fr';
    return localStorage.getItem('lang') || this.$store.getters['auth/userLang'] || defaultLang;
  }

  get entityPath(): string {
    return this.fetchPath
      ? `${this.$bpcApiRouteHelper.getTenantId()}/${this.getLang()}/${this.fetchPath}`
      : this.entityId
      ? `${this.$bpcApiRouteHelper.getEntityPath(this.entity)}/${this.entityId}`
      : null;
  }

  get entityDisplayConfigSlug(): string {
    return this.configPath ? this.configPath : `${this.entity}.displays.${this.displayConfigName}`;
  }

  created() {
    // this.$store.commit(`${this.storeName}/clearCanLoadEntities`, this.entity);
    if (this.flagsToCheckBeforeLoadEntity.includes('configLoaded')) {
      this.getConfig();
    }
    if (this.fetchEntity) {
      this.getEntity();
    } else {
      this.loading = false;
    }
  }

  getConfig() {
    this.$store.commit(`${this.storeName}/startLoadingConfig`, this.entity);

    this.loadingConfig = true;

    if (this.entityConfigSubscription) {
      this.entityConfigSubscription.unsubscribe();
    }
    this.entityConfigSubscription = this.$bpcConfig
      .getEntityConfig(this.entityDisplayConfigSlug)
      .subscribe(
        (res: BPCDisplayConfigResponse) => {
          if (res.data) {
            this.fields = res.data.fields;
            this.hiddenFields = res.data.hiddenFields;
            this.mainFields = res.data.mainFields;
          } else {
            this.fields = [];
            this.hiddenFields = [];
            this.mainFields = [];
          }
          this.$emit('on-load-config', res);
        },
        error => {
          console.log(error);
        },
        () => {
          this.$store.commit(`${this.storeName}/stopLoadingConfig`, this.entity);
          this.loadingConfig = false;
        },
      );
  }

  orderFields() {
    this.fields.sort((a, b) => a.order - b.order);
  }

  public getEntity(): void {
    if (this.entityPath && this.canLoadEntity) {
      this.$store.commit(`${this.storeName}/startLoadingEntity`, this.entity);
      this.loading = true;

      if (this.entitySubscription) {
        this.entitySubscription.unsubscribe();
      }
      let request = null;
      const queryConfig = {};
      request = this.getBPCRequestService().get(this.entityPath, queryConfig);

      this.entitySubscription = request.subscribe(
        (res: BPCGenericApiResponse) => {
          this.item = res.data;
          this.$emit('on-load-item', this.item);
        },
        error => {
          this.loading = false;
          console.log(error);
        },
        () => {
          this.loading = false;
          this.$store.commit(`${this.storeName}/stopLoadingEntity`, this.entity);
        },
      );
    }
  }

  public clearEntity(): void {
    this.item = {};
  }

  private getBPCRequestService() {
    // if (this.mode === 'storage') {
    //   return this.$bpcStorage;
    // } else {
    //   return this.$bpcApi;
    // }

    return this.$bpcApi;
  }

  @Watch('canLoadEntity')
  onCanLoadEntities() {
    if (this.canLoadEntity === true) {
      this.getEntity();
    }
  }
}
